import numberHelper from '@/helpers/numberHelper'

export default {
  methods: {
    capitalize (string) {
      if (!string) return ''
      return string.toUpperCase()
    },
    numberToCurrency (number) {
      return numberHelper.numberToCurrency(number)
    },
    decimalToPercentage (decimal) {
      return decimal * 100
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/utility.js